import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

import { retrieve_reservation, cancel_reservaton } from '../api/reservaton';
import { ActivityModal } from '../components/Modal';
import { type ReservationCancelProps } from 'types/ScreenTypes';
import {
    type RetrieveReservationType,
    type CancelReservationType,
} from 'types/API';
import { type ReservationType } from 'types/Schema';
import Dialog from '../components/Dialog/Dialog';
import { addDataToInfoMap } from '../utils/Utils';
import {
    NOT_AVAILABLE_CODE,
    NOT_FOUND_CODE,
    SUCCESS_MESSAGE_CODE,
    VALIDATION_MESSAGE_CODE,
} from '../const/messagesCode';
import { useTranslation } from 'react-i18next';
import { Button } from '@rneui/themed';

const styles = StyleSheet.create({
    container: {
        width: '100%',
        padding: 24,
        backgroundColor: '#fff',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

const ReservationCancel: React.FC<ReservationCancelProps> = ({
    navigation,
    route,
}) => {
    const { t } = useTranslation();
    const params = route.params;
    const [messageItem, setMessageItem] = React.useState<{
        message_code: number;
        message: string;
    }>({
        message_code: 0,
        message: '',
    });

    const columnOrderMap = {
        name: {
            name: t('name'),
            type: 'text',
        },
        reservation_date: {
            name: t('date'),
            type: 'text',
        },
        reservation_time: {
            name: t('time'),
            type: 'text',
        },
        people_num: {
            name: t('peopleNumber'),
            type: 'text',
        },
        table: {
            name: t('table'),
            type: 'image',
        },
    };

    const [notFound, setNotFound] = React.useState(false);

    const [modalState, setModalState] = React.useState({
        isVisible: true,
        loading: true,
    });
    const [reserevation, setReservation] =
        React.useState<ReservationType | null>(null);

    const afterSubmit = (data: CancelReservationType): void => {
        console.log(data);
        let message = '';
        if (data?.message_code === SUCCESS_MESSAGE_CODE) {
            message = t('reservationCancelled');
        } else if (data?.message_code === VALIDATION_MESSAGE_CODE) {
            message = 'Validation Error';
        } else if (
            data?.message_code === NOT_FOUND_CODE ||
            data?.message_code === NOT_AVAILABLE_CODE
        ) {
            message = t('reservationAlreadyCancelled');
        } else {
            message = t('serverError');
        }
        setMessageItem({
            message,
            message_code: data?.message_code,
        });
        setModalState({
            isVisible: true,
            loading: false,
        });
    };

    const handleFinalModal = (): void => {
        setModalState({
            isVisible: false,
            loading: modalState.loading,
        });
        navigation.navigate('Reservation');
    };

    const submitCancel = (): void => {
        console.log(reserevation);
        setModalState({
            isVisible: true,
            loading: true,
        });
        if (reserevation !== null) {
            void cancel_reservaton(reserevation.reservation_id, afterSubmit);
        }
    };

    const afterRetrieveReservation = (data: RetrieveReservationType): void => {
        const result = data?.item;
        console.log(result);
        if (result === null || result === undefined) {
            setNotFound(true);
        }
        setReservation(result);
        setModalState({
            isVisible: false,
            loading: modalState.loading,
        });
    };

    React.useEffect(() => {
        void retrieve_reservation(
            params?.reservation_id,
            afterRetrieveReservation
        );
    }, []);

    return (
        <View style={styles.container}>
            <ActivityModal
                modalState={modalState}
                closeFunc={handleFinalModal}
                message={messageItem?.message}
            />

            {reserevation !== null && reserevation !== undefined && (
                <>
                    <Dialog
                        data={addDataToInfoMap(reserevation, columnOrderMap)}
                        title={t('reservation') + ' ' + t('cancel')}
                    />
                    <Button title={t('cancel')} onPress={submitCancel} />
                </>
            )}
            {notFound && (
                <View>
                    <Text>{t('noReservationFound')}</Text>
                </View>
            )}
        </View>
    );
};

export default ReservationCancel;
